module.exports = __webpack_public_path__ + "img/Tonearm Generic.d57d6355.png";